import { Component, Input } from "@angular/core";
import { IPopupContentComponent, MessageBox } from "@geolib/geoappbase-client";
import DxPopup from "devextreme/ui/popup";
import IDataset from "../../IDataset";
import { FormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";


@Component({
    selector: "pro-reject-dialog",
    templateUrl: "./proRejectDialog.html",
    imports: [FormsModule, TranslatePipe],
})
export default class ProRejectDialog implements IPopupContentComponent {

    @Input() public dataset: IDataset;
    @Input() public updateFeedback: () => void;
    @Input() public proApprove: () => void;
    @Input() public proReject: () => void;
    @Input() public feedbackRequired: boolean;

    public approveAction: string;

    private popupInstance: DxPopup | undefined;

    public constructor(
        private readonly messageBox: MessageBox,
    ) {
    }

    public onPopupInstanceCreated(popup: DxPopup): void {
        this.popupInstance = popup;
        this.updateButtons();
    }

    private updateButtons(): void {
        if (!this.popupInstance) {
            return;
        }

        const toolbarItems = [this.messageBox.createSecondaryButton("NAVIGATION.ABORT", () => this.cancel())];

        if (this.approveAction === "approve") {
            toolbarItems.push(this.messageBox.createPrimaryButton(
                "DATASET_DIALOG.BUTTON.OKAY",
                () => this.approve(),
            ));
        } else if (this.approveAction === "reject") {
            toolbarItems.push(this.messageBox.createPrimaryButton(
                "DATASET_DIALOG.BUTTON.NOT_OKAY",
                () => this.reject(),
                () => this.feedbackRequired,
            ));
        }

        this.popupInstance.beginUpdate();
        this.popupInstance.instance().option("toolbarItems", toolbarItems);
        this.popupInstance.endUpdate();
    }

    public onApproveActionChanged(): void {
        if (this.approveAction === "reject") {
            this.updateFeedback();
        }
        this.updateButtons();
    }

    public onApprovedNoteChanged(): void {
        this.updateButtons();
    }

    public cancel(): void {
        this.messageBox.hideAll();
    }

    public approve(): void {
        this.proApprove();
        this.cancel();
    }

    public reject(): void {
        this.proReject();
        this.cancel();
    }

}
